var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCosplay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Funny-Mask--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Funny Mask Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.37 15.86a0.78 0.78 0 0 0 -0.63 -0.1 7.24 7.24 0 0 1 -5.39 -0.42l-1 -0.61a2.55 2.55 0 0 0 0.7 -4h0.42a5 5 0 0 0 4.9 -4H23a1 1 0 0 0 0 -2h-0.66a5 5 0 0 0 -9.68 -0.48 3.39 3.39 0 0 0 -1.27 0 5 5 0 0 0 -9.68 0.48H1a1 1 0 0 0 0 2h0.71a5 5 0 0 0 4.9 4H7a2.52 2.52 0 0 0 -0.7 1.75 2.56 2.56 0 0 0 1.4 2.23l-1 0.63a7.28 7.28 0 0 1 -5.4 0.42 0.78 0.78 0 0 0 -0.63 0.1 0.77 0.77 0 0 0 -0.33 0.54c-0.34 2.45 0.54 3.76 1.3 4.43a5.07 5.07 0 0 0 4.12 1 4.08 4.08 0 0 0 3 1.23A5.58 5.58 0 0 0 12 22a5.46 5.46 0 0 0 3.23 1l0.35 0a4 4 0 0 0 2.66 -1.22 5.07 5.07 0 0 0 4.12 -1c0.76 -0.67 1.61 -2 1.34 -4.43a0.77 0.77 0 0 0 -0.33 -0.49ZM17.44 2.71a3 3 0 1 1 -2.23 5l0 -0.05a3 3 0 0 1 -0.74 -2 3 3 0 0 1 2.97 -2.95Zm-5 3.53a4.91 4.91 0 0 0 1.06 2.57l0.67 2.35a1 1 0 0 0 1 0.72 0.56 0.56 0 0 1 0.57 0.57 0.55 0.55 0 0 1 -0.82 0.5 1 1 0 0 0 -1.37 0.57 1.6 1.6 0 0 1 -3 0 1 1 0 0 0 -0.94 -0.67 1.08 1.08 0 0 0 -0.43 0.1 0.55 0.55 0 0 1 -0.82 -0.5 0.56 0.56 0 0 1 0.57 -0.57 1 1 0 0 0 1 -0.72l0.67 -2.34a5 5 0 0 0 1.06 -2.58 1.06 1.06 0 0 1 0.8 0Zm-8.83 -0.53a3 3 0 0 1 6 -0.06v0.06a3 3 0 0 1 -0.74 2l0 0.05a3 3 0 0 1 -2.22 1 3 3 0 0 1 -3.04 -3.05Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCosplay);
export default ForwardRef;